const LIMIT_SMALL = 10
const LIMIT_MEDIUM = 25
const LIMIT_LARGE = 50

module.exports = {
  LIMIT_SMALL,
  LIMIT_MEDIUM,
  LIMIT_LARGE,
}
